import Axios from "axios";
import store from "../store/store";
import Queue from "../services/Providers/Queue";

const tokenKey = process.env.VUE_APP_COOKIE_AUTH || "Union.AuthCookieJwt";

const AxiosQueue = new Queue();

Axios.interceptors.request.use(
  config => {
    if (store.state.auth.isUserLoggedIn()) {
      config.headers.Authorization = `Bearer ${$cookies.get(tokenKey)}`;
    }

    const CancelToken = Axios.CancelToken;
    config.cancelToken = new CancelToken(c => {
      config.cancel = c;
    });

    if (AxiosQueue.has(config.url)) {
      AxiosQueue.get(config.url).cancel("Request canceled!");
      AxiosQueue.remove(config.url);
    }

    AxiosQueue.add(config.url, config);

    return AxiosQueue.get(config.url);
  },
  error => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  config => {
    if (AxiosQueue.has(config.config.url)) {
      AxiosQueue.remove(config.config.url);
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
